import CheckoutPageLayout from './CheckoutPageLayout';
import CheckoutMaxRetryErrorImage from '../images/checkout-max-retry-error.svg';
import Text from '@raydiant/raydial/components/Text';
import Button from '@raydiant/raydial/components/Button';

interface CheckoutSuccessPageProps {
  onGoBack: () => void;
  onGoToPaymentSubscriptions: () => void;
}

const CheckoutMaxRetryErrorPage = ({
  onGoBack,
  onGoToPaymentSubscriptions,
}: CheckoutSuccessPageProps) => {
  return (
    <CheckoutPageLayout onGoBack={onGoBack}>
      <div className="flex flex-1 flex-col items-center justify-center">
        <img
          src={CheckoutMaxRetryErrorImage}
          alt="Checkout Max Retry Error"
          className="w-23 h-auto mb-4"
        />

        <div className="flex flex-col gap-1 text-center mb-8">
          <Text variant="smallSubheader" className="text-black">
            Oops, it looks like something went wrong
          </Text>
          <Text variant="body" className="text-gray-600">
            Please check your orders in Payment & Subscriptions.
          </Text>
        </div>

        <Button
          variant="primary"
          size="medium"
          onPress={onGoToPaymentSubscriptions}
        >
          Go to Payment & Subscriptions
        </Button>
      </div>
    </CheckoutPageLayout>
  );
};

export default CheckoutMaxRetryErrorPage;
